import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AdBanner from '../components/AdBanner';
import './AboutPage.css';

function AboutPage() {
  useEffect(() => {
    document.title = '소개 - 로또운세';
  }, []);

  return (
    <div className="about-page">
      <div className="about-header">
        <h1>🎰🔮 로또운세</h1>
        <p className="tagline">AI 기반 로또 번호 추천과 매일 새로운 운세</p>
      </div>

      <AdBanner />

      <div className="about-content">
        <section className="about-section intro">
          <h2>서비스 소개</h2>
          <p>
            로또운세는 인공지능 기술을 활용하여 로또 번호를 생성하고,
            GPT가 매일 새롭게 작성하는 운세를 제공하는 종합 행운 플랫폼입니다.
          </p>
          <p>
            재미와 즐거움을 추구하면서도, 1,200회 이상의 로또 데이터를 기반으로
            통계적 분석과 다양한 알고리즘을 제공하여 사용자에게 의미 있는
            인사이트를 제공합니다.
          </p>
        </section>

        <section className="about-section features">
          <h2>주요 기능</h2>
          <div className="features-grid">
            <div className="feature-box">
              <div className="feature-icon">🎲</div>
              <h3>7가지 생성 알고리즘</h3>
              <p>
                랜덤, 통계 기반, 핫&콜드 넘버, 패턴 분석, 균형 분포,
                구간 최적화, 하이브리드 모델 등 다양한 방식으로 번호 생성
              </p>
            </div>

            <div className="feature-box">
              <div className="feature-icon">📊</div>
              <h3>심층 통계 분석</h3>
              <p>
                제3회부터 최신 회차까지의 모든 당첨 번호 데이터를 기반으로
                번호별 출현 빈도, 최근 트렌드를 시각화
              </p>
            </div>

            <div className="feature-box">
              <div className="feature-icon">🔮</div>
              <h3>AI 운세 생성</h3>
              <p>
                GPT-3.5 Turbo를 활용하여 매일 새벽 3시에 47개의 운세를
                자동 생성 (12별자리 + 12띠 + 타로 22장 + 행운)
              </p>
            </div>

            <div className="feature-box">
              <div className="feature-icon">🤖</div>
              <h3>자동화 시스템</h3>
              <p>
                매주 토요일 20:40부터 최신 로또 당첨 번호를 자동으로 크롤링하여
                항상 최신 데이터 유지
              </p>
            </div>
          </div>
        </section>

        <section className="about-section mission">
          <h2>우리의 미션</h2>
          <div className="mission-box">
            <p className="mission-text">
              "기술과 재미를 결합하여 사용자에게 즐거움과 희망을 선사한다"
            </p>
            <p>
              로또운세는 단순한 번호 생성기가 아닌, 데이터 분석과 인공지능을
              활용하여 사용자에게 의미 있는 경험을 제공하고자 합니다.
            </p>
            <p>
              동시에 운세를 통해 긍정적인 에너지와 하루를 시작하는 희망을
              전달하고자 합니다.
            </p>
          </div>
        </section>

        <section className="about-section stats">
          <h2>서비스 현황</h2>
          <div className="stats-grid">
            <div className="stat-box">
              <div className="stat-number">1,207+</div>
              <div className="stat-label">회차 데이터</div>
            </div>
            <div className="stat-box">
              <div className="stat-number">7</div>
              <div className="stat-label">생성 알고리즘</div>
            </div>
            <div className="stat-box">
              <div className="stat-number">47</div>
              <div className="stat-label">매일 운세 개수</div>
            </div>
            <div className="stat-box">
              <div className="stat-number">24/7</div>
              <div className="stat-label">서비스 운영</div>
            </div>
          </div>
        </section>

        <section className="about-section disclaimer">
          <h2>⚠️ 면책 조항</h2>
          <div className="disclaimer-box">
            <p>
              <strong>본 서비스는 재미와 참고용으로만 제공됩니다.</strong>
            </p>
            <ul>
              <li>로또 번호 생성은 통계와 알고리즘을 기반으로 하지만, 당첨을 보장하지 않습니다.</li>
              <li>운세 콘텐츠는 오락 목적이며, 실제 미래를 예측하지 않습니다.</li>
              <li>과도한 로또 구매는 경제적 어려움을 초래할 수 있습니다.</li>
              <li>책임감 있는 소비와 긍정적인 마인드를 권장합니다.</li>
            </ul>
          </div>
        </section>

        <section className="about-section cta">
          <h2>지금 시작하세요!</h2>
          <div className="cta-buttons">
            <Link to="/lotto" className="cta-btn primary">
              🎰 로또 번호 생성하기
            </Link>
            <Link to="/fortune" className="cta-btn secondary">
              🔮 오늘의 운세 보기
            </Link>
          </div>
        </section>
      </div>

      <AdBanner />
    </div>
  );
}

export default AboutPage;
